import { useState, useEffect } from 'react';

const usePlayerProfile = (memberIds, profilesUrl) => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const memberIdsKey = memberIds?.length ? memberIds.join(',') : '';

  useEffect(() => {
    if (!memberIdsKey || !profilesUrl) return;

    const controller = new AbortController();
    setLoading(true);
    setError(null);

    const queryString = memberIdsKey
      .split(',')
      .map((id) => `member_ids[]=${id}`)
      .join('&');

    fetch(`${profilesUrl}?${queryString}`, {
      signal: controller.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (!controller.signal.aborted) {
          setProfiles(data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          setError(err.message);
          setLoading(false);
        }
      });

    return () => controller.abort();
  }, [memberIdsKey, profilesUrl]);

  return { profiles, loading, error };
};

export default usePlayerProfile;
